import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LanguageProvider } from './shared/language-provider';
import { LanguagesService } from './shared/services/language.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from './shared/translate.directive';
import { LoginService } from './shared/services/login.service';
import { NavComponent } from "./nav/nav.component";
import { MatMenuModule } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LoaderService } from './shared/services/loader.service';
import { BehaviorSubject } from 'rxjs';
import { publishFacade } from '@angular/compiler';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, FormsModule, TranslateDirective, NavComponent, MatMenuModule, MatIconButton, MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less'
})

export class AppComponent {
  title = 'parkingweb';

  selectedLanguage: any;
  availableLanguages: any;
  defaultTrueLanguage: any;
  isLogged: boolean | undefined;
  isAdmin: boolean | undefined;
  user: any;
  isMenuOpen: any;
  isChangePassword = false;
  // public isLoading = new BehaviorSubject(false);

  constructor(private router: Router, public languageProvider: LanguageProvider,
    public langService: LanguagesService, public service: LoginService, private socialAuthService: SocialAuthService) { }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isChangePassword = event.urlAfterRedirects === '/change-password';
      }
    });
    this.languageProvider.langchange.subscribe(res => {
      this.setDefaultLanguage();
    });
    this.getAvailableLanguages();
    this.service.contextChange.subscribe(() => {
      this.isLogged = this.service.isAuthenticated();
      this.isAdmin = this.service.isAdmin();
    });
    this.isLogged = this.service.isAuthenticated();
    this.isAdmin = this.service.isAdmin();
    this.user = this.service.getUser();
  }
  apply() {
    this.router.navigate(['licence-application']);
  }
  goToUserDetails() {
    this.router.navigate(['user-profile']);
  }

  setDefaultLanguage() {
    this.selectedLanguage = this.languageProvider.getTranslatedItems().Code;
  }

  changeLanguage(event: any) {
    this.selectedLanguage = event;
    this.languageProvider.changeLanguage(this.selectedLanguage);
    // window.location.reload();
  }

  getAvailableLanguages() {
    this.langService.availableLanguages()
      .subscribe(response => {
        this.availableLanguages = response;
      });
  }

  logout() {
    this.service.isLoggingOut = true;

    this.socialAuthService.signOut(true)
      .then(() => this.finalizeLogout())
      .catch(() => this.finalizeLogout());
    this.service.logout();
    this.router.navigateByUrl('/login');
  }
  private finalizeLogout() {
    this.service.logout();
    this.router.navigateByUrl('/login').then(() => {
      setTimeout(() => {
        this.service.isLoggingOut = false;
      }, 500);
    });
  }
}
